import {
  Block,
  BottomSheet,
  Image,
  palette,
  SvgIcon,
  spacing,
  Touchable,
  Typography,
  useBreakpoints,
} from "@stepapp/ui";
import React, { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { StyleSheet, useWindowDimensions } from "react-native";

const WhatMakesUsDifferent = ({
  desktopImage,
  mobileImage,
}: {
  desktopImage?: string;
  mobileImage?: string;
}) => {
  const { t } = useTranslation();
  const { mobileOnly } = useBreakpoints();
  const { width: screenWidth, height: screenHeight } = useWindowDimensions();

  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = useCallback(() => {
    if (desktopImage || mobileImage) {
      setIsModalVisible(true);
    }
  }, [desktopImage, mobileImage]);

  const imageWidth = screenWidth > 402 ? 382 : screenWidth - 40;
  const imageHeight = screenHeight * 0.7;

  return (
    <>
      <Touchable onPress={showModal} style={styles.container}>
        <SvgIcon name="heart" size={22} color={palette.secondary.wrongPink} />
        <Typography variant="bodyBold" style={styles.text}>
          {t("screens.category.whatMakesUsDifferent")}
        </Typography>
        <SvgIcon
          name="chevron-right"
          size={22}
          color={palette.font.secondary}
          style={styles.chevron}
        />
      </Touchable>

      <BottomSheet toggle={() => setIsModalVisible(false)} visible={isModalVisible}>
        <Touchable onPress={() => setIsModalVisible(false)} style={styles.closeButton}>
          <Block alignCenter justifyCenter>
            <SvgIcon color={palette.font.primary} name="close" size={23} style={styles.closeIcon} />
          </Block>
        </Touchable>

        <Block alignCenter justifyCenter>
          <Image
            contentFit="contain"
            source={{ uri: mobileOnly ? mobileImage : desktopImage }}
            width={imageWidth}
            height={imageHeight}
            style={mobileOnly ? styles.image : styles.imageDesktop}
          />
        </Block>
      </BottomSheet>
    </>
  );
};

export default React.memo(WhatMakesUsDifferent);

const styles = StyleSheet.create({
  container: {
    backgroundColor: palette.secondary.lightGrey,
    borderRadius: spacing.radius,
    height: spacing.unit * 8,
    alignItems: "center",
    paddingHorizontal: spacing.unit * 3,
    flexDirection: "row",
  },
  text: {
    marginLeft: spacing.unit * 1.5,
  },
  chevron: {
    marginLeft: "auto",
  },
  image: {
    marginTop: spacing.unit * 4,
    marginBottom: spacing.unit * 8,
  },
  imageDesktop: {
    marginTop: spacing.unit * 2,
  },
  closeButton: {
    backgroundColor: palette.secondary.grey,
    borderRadius: spacing.unit * 2.5,
    height: spacing.unit * 4,
    justifyContent: "center",
    width: spacing.unit * 4,
    marginTop: spacing.unit * 2,
    alignSelf: "flex-end",
    marginHorizontal: spacing.unit * 2,
  },
  closeIcon: {
    marginRight: 1,
    marginBottom: 1,
  },
});
